import { ReactNode } from 'react';
import { MIN_QUERY_LENGTH } from '@/utils/search';
import styles from './Highlight.module.css';

export const Highlight = ({
  text,
  query,
}: {
  text: string;
  query: string;
}): ReactNode => {
  if (!query || query.length < MIN_QUERY_LENGTH) return <>{text}</>;

  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escaped})`, 'gi');
  const parts = text.split(regex);

  let offset = 0;
  const elements = parts.map((part) => {
    const key = `${part}-at-${offset}`;
    offset += part.length;
    return regex.test(part) ? (
      <mark key={key} className={styles.highlight}>
        {part}
      </mark>
    ) : (
      <span key={key}>{part}</span>
    );
  });

  return <>{elements}</>;
};
